import { Functions, httpsCallable } from "firebase/functions";

const getExternalFunctions = (functions: Functions) => {
  return {
    analyzeImage: httpsCallable(functions, "analyzeImage", {
      timeout: 300_000,
    }),
    getPrompt: httpsCallable(functions, "getPrompt"),
    saveToGoogleSheet: httpsCallable(functions, "saveToGoogleSheet"),
    // Funciones de gestión de prompts
    getPrompts: httpsCallable(functions, "getPrompts"),
    createPrompt: httpsCallable(functions, "createPrompt"),
    updatePrompt: httpsCallable(functions, "updatePrompt"),
    deletePrompt: httpsCallable(functions, "deletePrompt"),
  };
};

export default getExternalFunctions;
